(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-product-hero"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header      = document.querySelector('.section-header');
      this.headerWrap  = this.closest('.header-wrapper--product-hero');
      this.headerBounds = {};

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal    = false;

      this.onScrollHandler      = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createBoundsObserver();

      // Defer until window.load so CSS is fully applied before reading
      // computed background colours from section elements.
      if (document.readyState === 'complete') {
        this.tagSectionsFromBackground();
        this.initThemeDetection();
      } else {
        window.addEventListener('load', () => {
          this.tagSectionsFromBackground();
          this.initThemeDetection();
        }, { once: true });
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._themeScrollHandler) {
        window.removeEventListener('scroll', this._themeScrollHandler);
      }
    }

    createBoundsObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    /* ── AUTO-TAG SECTIONS ───────────────────────────────────────────────
       Runs once at load. Finds every Shopify section wrapper on the page,
       reads the computed background-colour of its first child element, and
       writes data-header-theme="dark" or "light" onto the wrapper.

       Sections that already carry data-header-theme (set manually in their
       own liquid) are left untouched — manual always wins.

       Works with:
        • Inline background colours  (background: #f0f0f0)
        • Dawn colour-scheme classes  (CSS custom properties resolved by
          getComputedStyle at runtime)
        • Any element where the background is set on the direct child of
          the shopify-section wrapper
    ──────────────────────────────────────────────────────────────────── */
    tagSectionsFromBackground() {
      document.querySelectorAll('[id^="shopify-section-"]').forEach(el => {
        if (el.hasAttribute('data-header-theme')) return; // manual override wins

        // If a child element has data-header-theme (e.g. header-theme-marker inner div),
        // promote that value to the wrapper so it's the single source of truth.
        const innerTag = el.querySelector('[data-header-theme]');
        if (innerTag) {
          el.setAttribute('data-header-theme', innerTag.getAttribute('data-header-theme'));
          return;
        }

        const child = el.firstElementChild;
        if (!child) { el.setAttribute('data-header-theme', 'dark'); return; }

        const bg = window.getComputedStyle(child).backgroundColor;

        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
          const nums = bg.match(/[\d.]+/g);
          if (nums && nums.length >= 3) {
            const lum = (0.299 * parseFloat(nums[0]) +
                         0.587 * parseFloat(nums[1]) +
                         0.114 * parseFloat(nums[2])) / 255;
            el.setAttribute('data-header-theme', lum > 0.5 ? 'light' : 'dark');
            return;
          }
        }

        // Transparent background — leave untagged so the theme marker above
        // (or the default-theme fallback) stays in effect for this section.
      });
    }

    /* ── SCROLL-BASED COLOUR THEMING ─────────────────────────────────────
       Reads data-header-theme="dark" or data-header-theme="light" from
       any element on the page. The last element whose top edge has
       crossed the midpoint of the viewport drives the header colour.

       Falls back to the data-default-theme attribute on the header
       wrapper (set from the section's "Default theme" setting).

       To tag a section, add to its outermost wrapper element:
         data-header-theme="light"   or   data-header-theme="dark"
    ──────────────────────────────────────────────────────────────────── */
    initThemeDetection() {
      if (!this.headerWrap) return;

      const applyTheme = () => {
        // Only query section wrappers — inner marker divs must not create duplicate signals.
        const themeEls   = document.querySelectorAll('[id^="shopify-section-"][data-header-theme]');
        const headerBottom = this.offsetHeight;
        const fallback   = this.headerWrap.getAttribute('data-default-theme') || 'dark';
        let   theme      = fallback;

        for (let i = themeEls.length - 1; i >= 0; i--) {
          if (themeEls[i].getBoundingClientRect().top <= headerBottom) {
            theme = themeEls[i].getAttribute('data-header-theme') || fallback;
            break;
          }
        }

        if (theme === 'light') {
          this.headerWrap.classList.add('header--light');
          this.headerWrap.classList.remove('header--dark');
        } else {
          this.headerWrap.classList.add('header--dark');
          this.headerWrap.classList.remove('header--light');
        }
      };

      this._themeScrollHandler = applyTheme;
      window.addEventListener('scroll', this._themeScrollHandler, { passive: true });
      window.addEventListener('resize', this._themeScrollHandler, { passive: true });
      applyTheme();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
